<template>
	<div class="page_container" :class="'p'+this.$route.name">
		<div class="page_hero p">
	  		<div>
	  			<h1>{{this.$route.meta.name}}</h1>
	  			<router-view class="sub_nav fade-in fade-out"></router-view>
	  			<div class="page_about">
  					<p>{{presentation}}</p>
  					<div class="actions">

  						<router-link class="routerlink" to="/immatriculation/carte_grise">
				  			<div class="action cartegrise">
				  				<div class="title">
				  					<h3>Carte grise</h3>
				  				</div>
				  				<div class="sub">
				  					<button>En savoir plus</button>
				  				</div>
				  			</div>
			  			</router-link>

						<router-link class="routerlink" to="/immatriculation/adresse">
				  			<div class="action adresse">
				  				<div class="title">
					  				<h3>Changement d'adresse</h3>
					  			</div>
					  			<div class="sub">
					  				<button>En savoir plus</button>
					  			</div>
				  			</div>
			  			</router-link>

						<router-link class="routerlink" to="/immatriculation/cession">
				  			<div class="action cession">
				  				<div class="title">
					  				<h3>Déclaration de cession</h3>
					  			</div>
					  			<div class="sub">
					  				<button>En savoir plus</button>
					  			</div>
				  			</div>
			  			</router-link>

						<router-link class="routerlink" to="/immatriculation/duplicata">
			  				<div class="action duplicata">
			  					<div class="title">
				  					<h3>Demande de duplicata</h3>
				  				</div>
				  				<div class="sub">
				  					<button>En savoir plus</button>
				  				</div>
			  				</div>
		  				</router-link>

						<router-link class="routerlink" to="/immatriculation/vehicule_etranger">
			  				<div class="action etranger">
			  					<div class="title">
				  					<h3>Véhicules étrangers</h3>
				  				</div>
				  				<div class="sub">
				  					<button>En savoir plus</button>
				  				</div>
			  				</div>
		  				</router-link>

						<router-link class="routerlink" to="/immatriculation/succession">
			  				<div class="action succession">
			  					<div class="title">
				  					<h3>Successions</h3>
				  				</div>
				  				<div class="sub">
				  					<button>En savoir plus</button>
				  				</div>
			  				</div>
		  				</router-link>

						<router-link class="routerlink" to="/immatriculation/collection">
			  				<div class="action collection">
			  					<div class="title">
				  					<h3>Véhicules de collection</h3>
				  				</div>
				  				<div class="sub">
				  					<button>En savoir plus</button>
				  				</div>
			  				</div>
		  				</router-link>

						<router-link class="routerlink" to="/immatriculation/autres_immat">
			  				<div class="action autres">
			  					<div class="title">
				  					<h3>Autres demandes</h3>
				  				</div>
				  				<div class="sub">
				  					<button>En savoir plus</button>
				  				</div>
			  				</div>
		  				</router-link>

			  		</div>
  				</div>
  			</div>
	  	</div>
	</div>	
</template>

<script>
	const fb = require('../firebaseConfig.js')
	import firebase from 'firebase'
	export default {
		name: 'Immatriculation',
		data () {
			return {
				presentation:''
			}
		},
		methods: {
		},
		mounted () {
			if(Object.keys(this.$store.state.static).length === 0){
				firebase.auth().signInAnonymously()
      			.then(() => {
					// console.log("object empty for matriculation")
					fb.db.collection('documents').doc(this.$route.meta.parent_name).get()
			  		.then(res => {
				  		this.presentation = res.data().presentation
			  		})
			  	})
			}else{
				// console.log("object not very empty my friend for matriculation")
				var doc = this.$store.state.static[this.$route.meta.parent_name]
		  		this.presentation = doc.presentation
			}
		}
	}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Immatriculation.vue